module.exports = __webpack_public_path__ + "web-icons.3ed7c2762ffa97fb77e6.woff2";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/web-icons/web-icons.woff2?v=0.2.3
// module id = ../../../../../src/fonts/web-icons/web-icons.woff2?v=0.2.3
// module chunks = 5